// src/app/guards/auth-child.guard.ts

import { Injectable } from '@angular/core';
import {
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthChildGuard implements CanActivateChild {
  constructor(private router: Router) {}

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    
    const hasAccess = this.checkChildAccess(childRoute); // Your logic here

    if (!hasAccess) {
      return this.router.createUrlTree(['/landing']); // Redirect if no access
    }

    return true;
  }

  private checkChildAccess(route: ActivatedRouteSnapshot): boolean {
    const userRole = sessionStorage.getItem('access');
    if(userRole){
      return true;
    }
    return false;
  }
}
